import { AttentionLevel } from "client/resources/attentionLevel";
import {ExclamationTriangleIcon, CheckIcon, HourglassIcon} from "@octopusdeploy/design-system-icons";
import React = require("react");
import {themeTokens} from "@octopusdeploy/design-system-tokens";
import moment from "moment";

const iconColor = themeTokens.color.icon;
const textColor = themeTokens.color.text;

const severelyExpiredThresholdHours = 12;

export function getAttentionIndicator(attentionLevel: AttentionLevel, isSnoozed?: boolean, lastUpdated?: string) : AttentionIndicator {
    switch (attentionLevel) {
        case AttentionLevel.Ok: return isSnoozed ? okSnoozed() : ok();
        case AttentionLevel.Expired: return isSnoozed ? expiredSnoozed() : expired(lastUpdated);
        case AttentionLevel.Warning: return isSnoozed ? alertOrWarningSnoozed() : warning();
        case AttentionLevel.Alert: return isSnoozed ? alertOrWarningSnoozed() : alert();
    }
}

export function warning() : AttentionIndicator {
    return {color: textColor.warning, icon: <ExclamationTriangleIcon size={24} color={iconColor.warning} />};
}

export function alert() : AttentionIndicator {
    return {color: textColor.danger, icon: <ExclamationTriangleIcon size={24} color={iconColor.danger} />};
}

export function alertOrWarningSnoozed() : AttentionIndicator {
    return {color: textColor.info, icon: <ExclamationTriangleIcon size={24} color={iconColor.info} />}
}

export function ok() : AttentionIndicator {
    return {color: textColor.success, icon: <CheckIcon size={24} color={iconColor.success} />};
}

export function okSnoozed() : AttentionIndicator {
    return {color: textColor.info, icon: <CheckIcon size={24} color={iconColor.info} />};
}

export function expiredSnoozed() : AttentionIndicator {
    return {color: textColor.info, icon: <HourglassIcon size={24} color={iconColor.info} />};
}

export function expired(lastUpdated?: string) : AttentionIndicator {
    const isSeverelyExpired = lastUpdated === undefined || moment().diff(lastUpdated, "hours") >= severelyExpiredThresholdHours;
    return isSeverelyExpired
        ? {color: textColor.danger, icon: <HourglassIcon size={24} color={iconColor.danger} />}
        : {color: textColor.tertiary, icon: <HourglassIcon size={24} color={iconColor.tertiary} />};
}

export interface AttentionIndicator {
    color: string;
    icon: JSX.Element;
}
